export default __webpack_public_path__ + "static/media/custimage2.5b1b7f57c7f81bb9c1c77c789cf26912.png";